import { useEffect, useState } from 'react';
import { getCourses, createCourse, updateCourse, deleteCourse } from '@services/courseService';
import { useAnalytics } from '../contexts/AnalyticsContext';

const useCourseData = () => {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { incrementData, decrementData } = useAnalytics();

  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const data = await getCourses();
        setCourses(data);
      } catch (error) {
        console.error('Error fetching courses:', error);
        setError('Failed to fetch courses data.');
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, []);

  const addCourse = async (courseData) => {
    try {
      const newCourse = await createCourse(courseData);
      setCourses(prev => [...prev, newCourse]);
      incrementData('total_courses');
    } catch (error) {
      console.error('Error adding course:', error);
      throw error;
    }
  };

  const editCourse = async (courseId, courseData) => {
    try {
      const updatedCourse = await updateCourse(courseId, courseData);
      setCourses(prev =>
        prev.map(course => (course.id === courseId ? updatedCourse : course))
      );
    } catch (error) {
      console.error('Error updating course:', error);
      throw error;
    }
  };

  const removeCourse = async (courseId) => {
    try {
      await deleteCourse(courseId);
      setCourses(prev => prev.filter(course => course.id !== courseId));
      decrementData('total_courses');
    } catch (error) {
      console.error('Error deleting course:', error);
      throw error;
    }
  };

  return {
    courses,
    loading,
    error,
    addCourse,
    editCourse,
    removeCourse,
  };
};

export default useCourseData;
